// src/components/Home.js
import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

const backgroundImages = ["Image17.jpeg", "ImageHomebg.jpg"];
const imageNames = [
  "Image1.jpeg","Image2.jpeg","Image3.jpeg","Image4.jpeg","Image5.jpeg",
  "Image6.jpeg","Image7.jpeg","Image8.jpeg","Image9.jpeg","Image10.jpeg",
  "Image11.jpeg","Image12.jpeg","Image13.jpeg","Image14.jpeg","Image15.jpeg",
  "Image16.jpeg","Image17.jpeg","Image18.jpeg","Image19.jpeg","Image20.jpeg",
  "Image21.jpeg","Image22.jpeg","Image23.jpeg","Image24.jpeg","Image25.jpeg",
];

const Home = () => {
  const [bgIndex, setBgIndex] = useState(0);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(true);
  const [reviewsError, setReviewsError] = useState(null);
  const carouselIntervalRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const startCarousel = () => {
    carouselIntervalRef.current = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % imageNames.length);
    }, 4000);
  };
  const stopCarousel = () => {
    if (carouselIntervalRef.current) {
      clearInterval(carouselIntervalRef.current);
      carouselIntervalRef.current = null;
    }
  };
  useEffect(() => {
    startCarousel();
    return () => stopCarousel();
  }, []);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setReviewsLoading(true);
        const res = await axios.get(
          `/api/reviews`
        );
        setReviews(res.data);
      } catch (err) {
        setReviewsError("Failed to load reviews.");
      } finally {
        setReviewsLoading(false);
      }
    };
    fetchReviews();
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

        :root {
          --gold: #C9A84C;
          --gold-light: #E8C97A;
          --dark: #0A0A0A;
          --charcoal: #1A1A1A;
          --cream: #F5F0E8;
        }

        * { box-sizing: border-box; }

        .home-root {
          font-family: 'Jost', sans-serif;
          background: var(--dark);
          color: white;
          overflow-x: hidden;
        }

        /* ── HERO ── */
        .hero {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .hero-bg {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          transition: opacity 1.8s ease-in-out;
          will-change: opacity;
        }
        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            160deg,
            rgba(0,0,0,0.72) 0%,
            rgba(10,10,10,0.55) 50%,
            rgba(0,0,0,0.80) 100%
          );
        }
        .hero-content {
          position: relative;
          z-index: 2;
          text-align: center;
          padding: 2rem 1.5rem;
          max-width: 960px;
          margin: 0 auto;
          animation: heroFadeUp 1.2s ease both;
        }
        @keyframes heroFadeUp {
          from { opacity:0; transform:translateY(32px); }
          to   { opacity:1; transform:translateY(0); }
        }
        .hero-eyebrow {
          font-family: 'Jost', sans-serif;
          letter-spacing: 5px;
          text-transform: uppercase;
          font-size: 0.75rem;
          font-weight: 500;
          color: var(--gold);
          margin-bottom: 1.4rem;
        }
        .hero-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.8rem, 7vw, 5.5rem);
          font-weight: 700;
          line-height: 1.08;
          letter-spacing: -0.5px;
          color: #fff;
          margin-bottom: 1.8rem;
        }
        .hero-title em {
          font-style: italic;
          color: var(--gold-light);
        }
        .hero-divider {
          width: 60px;
          height: 2px;
          background: var(--gold);
          margin: 0 auto 1.8rem;
        }
        .hero-subtitle {
          font-size: clamp(0.95rem, 2vw, 1.15rem);
          font-weight: 300;
          color: rgba(255,255,255,0.85);
          line-height: 1.85;
          max-width: 660px;
          margin: 0 auto 2.5rem;
        }
        .hero-pills {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
          justify-content: center;
          margin-bottom: 2.8rem;
        }
        .hero-pill {
          border: 1px solid rgba(201,168,76,0.5);
          color: var(--gold-light);
          padding: 0.35rem 1.1rem;
          border-radius: 50px;
          font-size: 0.78rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          font-weight: 500;
        }
        .btn-gold {
          background: var(--gold);
          color: #0A0A0A;
          border: none;
          padding: 0.85rem 2.8rem;
          font-family: 'Jost', sans-serif;
          font-weight: 600;
          font-size: 0.85rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          border-radius: 3px;
          cursor: pointer;
          transition: background 0.3s, transform 0.2s;
          text-decoration: none;
          display: inline-block;
        }
        .btn-gold:hover {
          background: var(--gold-light);
          transform: translateY(-2px);
          color: #0A0A0A;
        }
        .hero-scroll {
          position: absolute;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.4rem;
          color: rgba(255,255,255,0.5);
          font-size: 0.65rem;
          letter-spacing: 3px;
          text-transform: uppercase;
        }
        .scroll-line {
          width: 1px;
          height: 40px;
          background: linear-gradient(to bottom, var(--gold), transparent);
          animation: scrollPulse 2s ease-in-out infinite;
        }
        @keyframes scrollPulse {
          0%,100% { opacity:0.4; } 50% { opacity:1; }
        }

        /* ── STATS BAR ── */
        .stats-bar {
          background: var(--charcoal);
          border-top: 1px solid rgba(201,168,76,0.2);
          border-bottom: 1px solid rgba(201,168,76,0.2);
          padding: 2rem 1rem;
        }
        .stat-item {
          text-align: center;
          padding: 0.5rem 1rem;
        }
        .stat-number {
          font-family: 'Cormorant Garamond', serif;
          font-size: 2.6rem;
          font-weight: 700;
          color: var(--gold);
          line-height: 1;
        }
        .stat-label {
          font-size: 0.7rem;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.5);
          margin-top: 0.3rem;
        }

        /* ── CAROUSEL SECTION ── */
        .gallery-section {
          padding: 6rem 0 5rem;
          background: var(--dark);
        }
        .section-label {
          text-align: center;
          font-size: 0.7rem;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.8rem;
        }
        .section-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem, 5vw, 3.2rem);
          font-weight: 600;
          text-align: center;
          color: #fff;
          margin-bottom: 0.6rem;
        }
        .section-line {
          width: 50px;
          height: 2px;
          background: var(--gold);
          margin: 0 auto 3rem;
        }

        /* Carousel wrapper — fixed height, hidden overflow */
        .carousel-frame {
          position: relative;
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          border-radius: 6px;
          overflow: hidden;
          box-shadow: 0 30px 80px rgba(0,0,0,0.6);
          /* Aspect ratio trick: 16:9 */
          aspect-ratio: 16 / 9;
          background: #111;
        }
        .carousel-frame img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: opacity 1.2s ease-in-out;
        }

        /* Carousel nav dots */
        .carousel-dots {
          display: flex;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1.5rem;
        }
        .c-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.3);
          transition: background 0.3s, transform 0.3s;
          cursor: pointer;
          border: none;
          padding: 0;
        }
        .c-dot.active {
          background: var(--gold);
          transform: scale(1.4);
        }

        /* ── REVIEWS ── */
        .reviews-section {
          background: var(--charcoal);
          padding: 6rem 0;
        }
        .review-card {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(201,168,76,0.15);
          border-radius: 6px;
          padding: 2rem;
          height: 100%;
          transition: border-color 0.3s, transform 0.3s;
        }
        .review-card:hover {
          border-color: rgba(201,168,76,0.5);
          transform: translateY(-4px);
        }
        .review-stars {
          color: var(--gold);
          font-size: 1rem;
          letter-spacing: 2px;
          margin-bottom: 1rem;
        }
        .review-text {
          font-size: 0.93rem;
          line-height: 1.75;
          color: rgba(255,255,255,0.78);
          font-style: italic;
          margin-bottom: 1.2rem;
        }
        .review-author {
          font-size: 0.75rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--gold);
          font-weight: 500;
        }

        /* ── CTA BAND ── */
        .cta-band {
          background: linear-gradient(135deg, #1a1200 0%, #2a1f00 50%, #1a1200 100%);
          border-top: 1px solid rgba(201,168,76,0.25);
          border-bottom: 1px solid rgba(201,168,76,0.25);
          padding: 5rem 1.5rem;
          text-align: center;
        }
        .cta-band h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2rem, 5vw, 3.5rem);
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
        }
        .cta-band p {
          color: rgba(255,255,255,0.7);
          font-size: 1rem;
          margin-bottom: 2.5rem;
          max-width: 540px;
          margin-left: auto;
          margin-right: auto;
        }

        /* ── RESPONSIVE ── */
        @media (max-width: 576px) {
          .carousel-frame { border-radius: 4px; }
          .stats-bar .row { gap: 0.5rem; }
        }
      `}</style>

      <div className="home-root">

        {/* ── HERO ── */}
        <section className="hero">
          {backgroundImages.map((img, i) => (
            <div
              key={i}
              className="hero-bg"
              style={{
                backgroundImage: `url(/images/${img})`,
                opacity: i === bgIndex ? 1 : 0,
              }}
            />
          ))}
          <div className="hero-overlay" />
          <div className="hero-content">
            <p className="hero-eyebrow">Nairobi · Kenya · Est. 2024</p>
            <h1 className="hero-title">
              Nairobi's <em>Ultimate</em><br />City Tours &amp; Adventures
            </h1>
            <div className="hero-divider" />
            <p className="hero-subtitle">
              We turn your visit into an unforgettable journey — blending wildlife,
              culture, history, and adventure. Every moment is crafted with precision
              so you leave with stories worth telling.
            </p>
            <div className="hero-pills">
              <span className="hero-pill">Experienced Guides</span>
              <span className="hero-pill">Unique Itineraries</span>
              <span className="hero-pill">Hassle-Free</span>
            </div>
            <a href="/tours" className="btn-gold">Book Your Experience</a>
          </div>
          <div className="hero-scroll">
            <div className="scroll-line" />
            <span>Scroll</span>
          </div>
        </section>

        {/* ── STATS BAR ── */}
        <div className="stats-bar">
          <div className="container">
            <div className="row justify-content-center">
              {[
                { number: "500+", label: "Happy Guests" },
                { number: "4", label: "Tour Types" },
                { number: "100%", label: "Local Expertise" },
                { number: "5★", label: "Rated Experience" },
              ].map((s, i) => (
                <div key={i} className="col-6 col-md-3">
                  <div className="stat-item">
                    <div className="stat-number">{s.number}</div>
                    <div className="stat-label">{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── GALLERY / CAROUSEL ── */}
        <section className="gallery-section">
          <p className="section-label">Experience Gallery</p>
          <h2 className="section-title">Moments from the Field</h2>
          <div className="section-line" />

          <div className="container-fluid px-3 px-md-5">
            <div
              className="carousel-frame"
              onMouseEnter={stopCarousel}
              onMouseLeave={startCarousel}
            >
              {imageNames.map((img, i) => (
                <img
                  key={i}
                  src={`/images/${img}`}
                  alt={`Nairobi tour moment ${i + 1}`}
                  style={{ opacity: i === carouselIndex ? 1 : 0 }}
                  loading={i === 0 ? "eager" : "lazy"}
                />
              ))}
            </div>

            {/* Dots — show a window of 7 around current */}
            <div className="carousel-dots">
              {imageNames.slice(0, 7).map((_, i) => {
                const step = Math.floor(carouselIndex / (imageNames.length / 7));
                return (
                  <button
                    key={i}
                    className={`c-dot ${i === step ? "active" : ""}`}
                    onClick={() => setCarouselIndex(Math.floor(i * imageNames.length / 7))}
                    aria-label={`Go to slide group ${i + 1}`}
                  />
                );
              })}
            </div>

            <div className="text-center mt-4">
              <a href="/tours" className="btn-gold">View All Tours</a>
            </div>
          </div>
        </section>

        {/* ── REVIEWS ── */}
        <section className="reviews-section">
          <div className="container">
            <p className="section-label">Testimonials</p>
            <h2 className="section-title">What Our Guests Say</h2>
            <div className="section-line" />

            {reviewsLoading && (
              <p className="text-center" style={{ color: "rgba(255,255,255,0.5)" }}>
                Loading reviews…
              </p>
            )}
            {reviewsError && (
              <p className="text-center text-danger">{reviewsError}</p>
            )}
            {!reviewsLoading && !reviewsError && reviews.length === 0 && (
              <p className="text-center" style={{ color: "rgba(255,255,255,0.5)" }}>
                No reviews yet — be the first to share your experience!
              </p>
            )}
            {!reviewsLoading && !reviewsError && reviews.length > 0 && (
              <div className="row g-4">
                {reviews.map((review, i) => (
                  <div key={i} className="col-md-6 col-lg-4">
                    <div className="review-card">
                      <div className="review-stars">
                        {"★".repeat(Math.min(review.review?.rating || 5, 5))}
                        {"☆".repeat(5 - Math.min(review.review?.rating || 5, 5))}
                      </div>
                      <p className="review-text">
                        "{review.review?.comment || "No comment provided."}"
                      </p>
                      <div className="review-author">— {review.firstName}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* ── CTA BAND ── */}
        <section className="cta-band">
          <h2>Your Nairobi Adventure Awaits</h2>
          <p>
            Join hundreds of travellers who've experienced Nairobi beyond the
            ordinary. Let's craft your journey today.
          </p>
          <a href="/tours" className="btn-gold">Book Now</a>
        </section>

      </div>
    </>
  );
};

export default Home;
